// extracted by mini-css-extract-plugin
export default {"card":"Q7-z"};